import { expandedState } from '@atlaskit/editor-common/expand';
import { fg } from '@atlaskit/platform-feature-flags';
export var updateExpandedState = function updateExpandedState(tr, node, isLivePage) {
  if (isLivePage || fg('platform-editor-single-player-expand')) {
    var wasExpandExpanded = expandedState.get(node.node);
    var newExpand = tr.doc.nodeAt(node.pos);
    if (wasExpandExpanded !== undefined && newExpand) {
      expandedState.set(newExpand, wasExpandExpanded);
    }
  }
};